<div
  [class.field-invalid]="showError"
  class="field-quantity-wrapper"
>
  <button
    (click)="decrease()"
    [disabled]="disabled"
    [portalCyTest]="field.key + 'Decrease'"
    class="field-button-icon"
    type="button"
  >
    <mat-icon>remove</mat-icon>
  </button>

  <input
    [class.opacity-30]="disabled"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [id]="id + 'Input'"
    [placeholder]="props.placeholder"
    [portalCyTest]="field.key + 'Input'"
    [readonly]="disabled"
    [required]="props.required || false"
    [tabIndex]="props.tabindex"
    class="field-input text-center"
    portalFormInputNumber
    type="text"
  />

  <button
    (click)="increase()"
    [disabled]="disabled"
    [portalCyTest]="field.key + 'Increase'"
    class="field-button-icon"
    type="button"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>

<mat-slider
  (change)="sliderChange($event)"
  [disabled]="disabled"
  [id]="id + 'Slider'"
  [max]="props.max"
  [min]="props.min"
  [portalCyTest]="field.key + 'Slider'"
  [step]="props.step"
  [tabIndex]="props.tabindex"
  [value]="formControl.value"
  class="field-slider"
>
</mat-slider>

<div class="field-quantity-label">
  <div class="text-left">
    <div>{{ props.prefix }}</div>
    <div>{{ props.min ?? '' | mask: 'separator.2' }}{{ props.suffix }}</div>
  </div>

  <!--  <div class="text-center">-->
  <!--    <div>Step: {{ props.step }}</div>-->
  <!--    <div>Value: {{ formControl.value }}</div>-->
  <!--    <div>Masked: {{ formControl.value ?? '' | mask: 'separator.2' }}{{ props.suffix }}</div>-->
  <!--  </div>-->

  <div class="text-right">
    <div>{{ props.prefix }}</div>
    <div>{{ props.max ?? '' | mask: 'separator.2' }}{{ props.suffix }}</div>
  </div>
</div>
